// extracted by mini-css-extract-plugin
export var content = "EduNews-module--content--21a23";
export var cta = "EduNews-module--cta--4630d";
export var logo = "EduNews-module--logo--5d024";
export var wrapper = "EduNews-module--wrapper--29e98";